import { Service, inject } from '@angular/core';
import { AlertaService } from './alerta.service';

const ICONE_SAIR = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="m16 17 5-5-5-5" />
    <path d="M21 12H9" />
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
  </svg>`;

@Service()
export class ConfirmacaoSaidaService {
  private readonly alerta = inject(AlertaService);

  confirmar(): Promise<boolean> {
    return this.alerta.confirmar({
      titulo: 'Sair da sua conta?',
      texto: 'Você precisará entrar novamente para acessar a área do cidadão.',
      confirmar: 'Sim, sair',
      cancelar: 'Continuar conectado',
      icone: ICONE_SAIR,
    });
  }
}
